import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { cloneDeep, filter, indexOf, map, sortBy } from 'lodash';

@Component({
  selector: 'app-geofence-select-dialog',
  templateUrl: './geofence-select-dialog.component.html',
  styleUrls: ['./geofence-select-dialog.component.scss']
})
export class GeofenceSelectDialogComponent implements OnInit {

  geofences: any[] = [];
  selected: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GeofenceSelectDialogComponent>,
  ) {
    this.geofences = cloneDeep(sortBy(this.data.geofences, ['name']));
    this.selected = cloneDeep(this.data.selected);
  }

  ngOnInit(): void {
    
  }

  toggleSelect(geofence: any) {
    if (this.isSelected(geofence)) {
      this.selected = filter(this.selected, (item) => item.id !== geofence.id);
    } else {
      this.selected.push(geofence);
    }
  }

  isSelected(geofence: any) {
    return indexOf(map(this.selected, 'id'), geofence.id) > -1;
  }

  selectAll() {
    this.selected = cloneDeep(this.geofences);
  }

  selectNone() {
    this.selected = [];
  }

  done() {
    this.dialogRef.close(this.selected);
  }

}
